export default __webpack_public_path__ + "static/media/Asset 11.7f37f7d4.svg";